import type { Faction } from '../../types/kotch';
import { FACTION_INFO, FACTION_ABILITIES } from '../../data/kotch/factionDecks';

interface PlayerBannerProps {
  playerName: string;
  faction: Faction | null;
  isAttacker: boolean;
  isOpponent?: boolean;
}

export default function PlayerBanner({
  playerName,
  faction,
  isAttacker,
  isOpponent = false,
}: PlayerBannerProps) {
  const factionInfo = faction ? FACTION_INFO[faction] : null;
  const factionAbility = faction ? FACTION_ABILITIES[faction] : null;

  return (
    <div
      className={`kotch-player-banner ${isOpponent ? 'opponent' : 'player'} ${isAttacker ? 'attacker' : 'defender'}`}
      style={factionInfo ? { '--banner-color': factionInfo.themeColor } as React.CSSProperties : undefined}
    >
      {/* Banner background image (faction_banner.png) */}
      {faction && (
        <div
          className="kotch-banner-bg"
          style={{ backgroundImage: `url(${getBannerPath(faction)})` }}
        />
      )}

      {/* Content overlay */}
      <div className="kotch-banner-content">
        <div className="kotch-banner-role-icon">
          {isAttacker ? '\u2694' : '\uD83D\uDEE1'}
        </div>
        <div className="kotch-banner-info">
          <span className="kotch-banner-name">{playerName}</span>
          {factionInfo && (
            <span
              className="kotch-banner-faction-tag"
              style={{ backgroundColor: factionInfo.themeColor }}
            >
              {factionInfo.name}
            </span>
          )}
        </div>
      </div>

      {/* Hover tooltip for faction ability */}
      {factionAbility && (
        <div className="kotch-banner-ability-tooltip">
          <span className="kotch-banner-ability-name">{factionAbility.name}</span>
          <span className="kotch-banner-ability-desc">{factionAbility.description}</span>
        </div>
      )}
    </div>
  );
}

function getBannerPath(faction: Faction): string {
  // Banner images placed in CardArt/ as faction_banner.png
  // Will gracefully fail if image doesn't exist yet (shows faction color fallback)
  try {
    return require(`./CardArt/${faction.toLowerCase()}_banner.png`);
  } catch {
    return '';
  }
}
